import React, { useContext, useEffect, useState } from 'react'
import LineChart from './LineChart'
import { AuthenticationContext } from '../../Auth/authentication.context'
import {
  DateFilterTemplate,
  SingleDateFilterTemplate,
} from '../shared/FilterTemplates'
import { formatCurrency, formatDate } from '../shared/utils'

import { useNavigate } from 'react-router-dom'

import server from '../../server'
import { Container, Row, Col, Card, CardBody, Spinner } from 'reactstrap'

// import images
import servicesIcon1 from '../../assets/images/services-icon/01.png'
import servicesIcon4 from '../../assets/images/services-icon/04.png'

import DashboardCards from './DashboardCards'

const ManufacturerDashboard = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  const { setIsLoading } = useContext(AuthenticationContext)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [data, setData] = useState(null)

  const titles = [
    'Total Orders Amount',
    '# of Orders',
    'Pending Orders Amount',
    '# of Pending Orders',
  ]
  const icons = [servicesIcon1, servicesIcon4, servicesIcon1, servicesIcon4]

  const handleStartDateChange = (date) => {
    setStartDate(date)
    if (endDate && date && endDate < date) {
      setEndDate(null)
    }
  }

  const handleEndDateChange = (date) => {
    setEndDate(date)
  }

  useEffect(() => {
    let url = '/dashboard/manufacturer'
    const params = []
    if (startDate) params.push(`startDate=${formatDate(startDate)}`)
    if (endDate) params.push(`endDate=${formatDate(endDate)}`)
    if (params.length > 0) url += '?' + params.join('&')

    server
      .get(url)
      .then((response) => {
        setIsLoading(false)
        setLoading(false)
        setData(response.data)
      })
      .catch((e) => {
        if (e.response && e.response.status === 401) {
          // handle unauthorized
        }
        setIsLoading(false)
        setLoading(false)
      })
  }, [startDate, endDate])

  document.title = 'Dashboard | Origins Direct'
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='page-title-box text-center text-md-start  '>
            <Row className='align-items-center '>
              <Col md={7}>
                <h6 className='page-title'>Dashboard</h6>
                <ol className='breadcrumb m-0'>
                  <li
                    className='breadcrumb-item active'
                    style={{ width: '100%' }}
                  >
                    Welcome to Origins Direct
                  </li>
                </ol>
              </Col>

              <Col md='5'>
                <div className=' d-flex gap-3 align-items-center justify-content-end'>
                  <h6 style={{ minWidth: '80px' }}>Date range:</h6>
                  <div className='d-flex gap-1'>
                    <SingleDateFilterTemplate
                      state={startDate}
                      stateHandler={(e) => handleStartDateChange(e.value)}
                      placeholder='From'
                      showIcon={false}
                    />
                    <SingleDateFilterTemplate
                      state={endDate}
                      stateHandler={(e) => handleEndDateChange(e.value)}
                      placeholder='To'
                      disabled={!startDate}
                      minDate={startDate}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {loading ? (
            <div
              className='d-flex justify-content-center align-items-center'
              style={{ height: '70vh' }}
            >
              <Spinner color='primary' />
            </div>
          ) : (
            <>
              <Row>
                {titles.map((title, index) => (
                  <Col key={index} xl={3} md={6}>
                    <Card className='mini-stat bg-primary text-white'>
                      <CardBody style={{ height: '120px' }}>
                        <DashboardCards
                          icon={icons[index]}
                          title={title}
                          value={
                            index === 0
                              ? data?.dashboard?.totalOrdersAmount
                              : index === 1
                              ? data?.totalNumberOfOrders
                              : index === 2
                              ? data?.dashboard?.pendingOrdersAmount
                              : data?.totalNumberOfPendingOrders
                          }
                        />
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>

              <Row>
                <Col xl={6}>
                  <Card>
                    <CardBody>
                      <h6 className='card-title mb-4'>Last Six Months</h6>
                    </CardBody>
                    <LineChart role='manufacturer' />
                  </Card>
                </Col>
                <Col xl={6}>
                  <Card>
                    <CardBody>
                      <h2 className='card-title mb-4'>Latest Orders</h2>
                      <div className='wid-peity mb-4'>
                        <div className='row'>
                          {data?.latestOrders?.map((item, idx) => (
                            <React.Fragment key={idx}>
                              <div>
                                <h6>Order #{item?.supplierInvoiceNo}</h6>
                                <p className='text-muted mb-4'>
                                  Total:{' '}
                                  {formatCurrency(item?.totalInvoiceAmount)} |
                                  PA: {formatCurrency(item?.totalInvoicePa)}
                                </p>
                              </div>
                            </React.Fragment>
                          ))}
                          <button
                            onClick={() =>
                              navigate('/manufacturer/manufacturerOrders')
                            }
                            className='text-center'
                            style={{
                              backgroundColor: 'transparent',
                              border: '0',
                              boxShadow: 'none',
                              opacity: '0.7',
                              fontSize: '12px',
                            }}
                          >
                            View All
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ManufacturerDashboard
